<div class="container-fluid" style="
      position: sticky;
      top: 0;
      z-index: 10;
">
  <div
    class="row pt-2 pb-2 align-items-center"
    style="
      background-image: linear-gradient(to right, #eb3349, #f45c43) !important;
      color: white;
    "
  >
    <div class="col-7 col-sm-9 col-lg-10 text-start">
      <p class="m-0 RB20">{{ eventDetailNew?.name }}</p>
    </div>
    <div class="col-5 col-sm-3 col-lg-2 text-end" >
      <button
      (click)="signUpWithGoogle()"
      class="w-100 white-stroke"
      mat-stroked-button
      style="background-color: white;"
    >
      <img
        style="height: auto; width: 20px"
        class="align-middle"
        src="assets/icon/google-logo-9824.png"
        alt=""
      />
      Sign in 
    </button>
    </div>
  </div>
</div>
<ng-template [ngIf]="!isLoading">
  <div class="container-fluid" style="position: sticky;
  z-index: 10;
">
    <div class="row">
      <div *ngIf="eventDetailNew?.files?.length">
        <div class="row">
          <div
            class="col-8 p-3"
            style="
              left: 0;
              padding-bottom: 0.5rem !important;
              z-index: 1;
              background: white;
            "
          >
            {{ eventDetailNew?.date * 1000 | date : "EEEE,  d MMM YY" }}
          </div>
          <div
            class="col-4 p-3"
            style="
              right: 0;
              padding-bottom: 0.5rem !important;
              text-align: end;
              z-index: 1;
              background: white;
            "
          >
            {{ eventDetailNew?.count }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid" style="height: 90vh; overflow: scroll; padding-bottom: 5rem">
      <div *ngIf="eventDetailNew?.files?.length">
        <div class="row">
          <div class="col-12" #scrollContainer>
            <app-album-tabs [arrayImages]="eventDetailNew?.files"> </app-album-tabs>
          </div>
          <button style="position: fixed;
          bottom: 1rem;
          background-color: #f25344;
          left: 1rem;" mat-mini-fab color="accent" (click)="getLatestPhotos()" aria-label="Example icon button with a bookmark icon">
            <mat-icon>refresh</mat-icon>
          </button>
          <button style="position: fixed;
          bottom: 1rem;
          background-color: #f25344;
          right: 1rem;" mat-mini-fab color="accent" (click)="scrollToTop(scrollContainer)" aria-label="Example icon button with a bookmark icon">
            <mat-icon>arrow_upward</mat-icon>
          </button>
        </div>
    </div>
  </div>
</ng-template>
<ng-template [ngIf]="isLoading">
  <div style="height:90vh;">
   <span class="loader"></span>
</div>
</ng-template>
<!-- <ng-template [ngIf]="isLoading">
  <div class="m-4">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{ width: '100%', height: '20px' }"
    >
    </ngx-skeleton-loader>
    <div class="row" style="margin: 0px 0px -30px -13px">
      <div class="col-4" *ngFor="let item of [].constructor(31)">
        <ngx-skeleton-loader
          appearance="line"
          [theme]="{ width: '115%', height: '115px' }"
        >
        </ngx-skeleton-loader>
      </div>
    </div>
  
  </div>
</ng-template> -->
